import * as Yup from "yup";

/**
 * Test functions
 */

export function urlTest(this: Yup.TestContext, value: any) {
  if (!value) return true;

  if (value === 'https://' || value === 'mailto:' || value === 'tel:') {
    return this.createError({ message: 'This field is required' });
  }

  const [prefix, rest = ''] = value.split(':', 2);

  switch (prefix) {
    case 'https':
      return Yup.string().url().isValidSync(value)
        || this.createError({ message: 'URL is not valid' })

    case 'mailto':
      return Yup.string().email().isValidSync(rest)
        || this.createError({ message: 'Email address is not valid' })

    case 'tel':
      return Yup.string().isValidSync(rest)
        || this.createError({ message: 'Phone number is not valid' })

    default:
      return this.createError({
        message: `Unsupported prefix "${prefix}:"`,
      })
  }
}